/** Logo officiel JCONSULT MY Academia (PNG transparent embarqué en SVG). */
import logo from '../assets/logos/logo.svg';
/** Emblème seul (sans texte) — menu navigation compact. */
import logoMark from '../assets/logos/logo-mark.png';
/** Logo monochrome blanc — fond transparent (login/register sur fond sombre). */
import logoWhite from '../assets/logos/logo-white.svg';

/** Nom affiché de la plateforme (paramètres plateforme / branding public). */
export const APP_DISPLAY_NAME = 'JCONSULT MY Academia';

/** Logo couleur — fond clair ou sombre (transparence). */
export const JCONSULT_LOGO = logo;

/** Emblème (mortier + livre + étoiles) pour barres de navigation. */
export const JCONSULT_LOGO_MARK = logoMark;

/** Alias conservé pour compatibilité — même asset que {@link JCONSULT_LOGO}. */
export const JCONSULT_LOGO_FOOTER = logo;

/** Logo entièrement blanc, fond transparent — panneaux sombres (auth). */
export const JCONSULT_LOGO_WHITE = logoWhite;

/** @deprecated alias — préférer {@link JCONSULT_LOGO_WHITE} ou {@link JCONSULT_LOGO}. */
export const JCONSULT_LOGO_AUTH_PAGES = logoWhite;
